import React from "react";
import "./index.css";

const Loader = () => <div className="loader">Loading...</div>;

export default Loader;
